import { render, staticRenderFns } from "./OldRegGhardhaniForm.vue?vue&type=template&id=26acb120&scoped=true&"
import script from "./OldRegGhardhaniForm.vue?vue&type=script&lang=js&"
export * from "./OldRegGhardhaniForm.vue?vue&type=script&lang=js&"
import style0 from "./OldRegGhardhaniForm.vue?vue&type=style&index=0&id=26acb120&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26acb120",
  null
  
)

export default component.exports